import { defineComponent as v, ref as u, provide as s, h as t, Fragment as f, Teleport as c, nextTick as n } from "vue";
import g from "./ghl-ui.es1040.js";
import { loadingBarApiInjectionKey as m, loadingBarProviderInjectionKey as p } from "./ghl-ui.es1041.js";
import h from "./ghl-ui.es713.js";
import B from "./ghl-ui.es854.js";
import b from "./ghl-ui.es855.js";
const y = Object.assign(Object.assign({}, b.props), {
  to: {
    type: [String, Object, Boolean],
    default: void 0
  },
  containerClass: String,
  containerStyle: [String, Object],
  loadingBarStyle: {
    type: Object
  }
}), R = v({
  name: "LoadingBarProvider",
  props: y,
  setup(a) {
    const i = h(), r = u(null), l = {
      start() {
        var e;
        i.value ? (e = r.value) === null || e === void 0 || e.start() : n(() => {
          var o;
          (o = r.value) === null || o === void 0 || o.start();
        });
      },
      error() {
        var e;
        i.value ? (e = r.value) === null || e === void 0 || e.error() : n(() => {
          var o;
          (o = r.value) === null || o === void 0 || o.error();
        });
      },
      finish() {
        var e;
        i.value ? (e = r.value) === null || e === void 0 || e.finish() : n(() => {
          var o;
          (o = r.value) === null || o === void 0 || o.finish();
        });
      }
    }, {
      mergedClsPrefixRef: d
    } = B(a);
    return s(m, l), s(p, {
      props: a,
      mergedClsPrefixRef: d
    }), Object.assign(l, {
      loadingBarRef: r
    });
  },
  render() {
    var a, i;
    return t(f, null, t(c, {
      disabled: this.to === !1,
      to: this.to || "body"
    }, t(g, {
      ref: "loadingBarRef",
      containerStyle: this.containerStyle,
      containerClass: this.containerClass
    })), (i = (a = this.$slots).default) === null || i === void 0 ? void 0 : i.call(a));
  }
});
export {
  R as default,
  y as loadingBarProviderProps
};
